export const AFFORDABILITY_CALCULATOR_PATH = '/calculators/affordability';
export const LEGACY_AFFORDABILITY_PATH = '/affordability';

export const AFFORDABILITY_CALCULATOR_META = {
  title: 'Home Affordability Calculator - How Much House Can You Afford?',
  description:
    'Find out how much home you can afford based on your income, debts, and down payment. Supports US and Canadian mortgage rules. Instant results.',
  path: AFFORDABILITY_CALCULATOR_PATH,
} as const;
